module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedBlack.2044fb3.eot";